import { TBrand } from '../types/types';

// BRANDS names must be aligned with naming in Sitecore
export const BRANDS: { [key: string]: TBrand } = {
  CASE: 'CaseCe',
  NEW_HOLLAND: 'NewHollandCe',
};

export const BRAND_CSS_CLASSES = {
  CASE: 'casece',
  NEW_HOLLAND: 'newhollandce',
};
